export default __webpack_public_path__ + "static/media/trout mask replica.a6a3f729.png";